// src/components/FormSections/FormSectionResumen.js

import React, { useState, useEffect } from "react"
import { Row, Col, Progress, Button, Card, CardBody } from "reactstrap"
import FormikInput from "../Common/Formik/FormikInput"
import FormikInputPassword from "../Common/Formik/FormikInputPassword"
import FormikDatePicker from "../Common/Formik/FormikDatePicker"
import FormikInputCurp from "../Common/Formik/FormikInputCurp"
import FormikInputEmailPersonal from "../Common/Formik/FormikInputEmailPersonal"
import FormikSelect from "../Common/Formik/FormikSelect"
import DropzoneComponent from "../Common/DropzoneComponent"
import ImageCropComponent from "../Common/ImageCropComponent"

import Webcam from "../Common/WebcamComponent"
import { Link } from "react-router-dom"

// #region selectors
import { useControlEscolarIsLoading } from "store/selectors"
// #endregion

const FormSectionResumen = ({
  formik,
  toggleTab,
  resetForm,
  handleUpperCaseChange,
  handleLowerCaseChange,
  ResetContador,
}) => {
  //
  const [contador, setContador] = useState(0)

  const isLoading = useControlEscolarIsLoading()

  // #region functions
  const contarHasta100 = () => {
    let contador = 1
    const intervalo = setInterval(() => {
      //console.log(contador)
      if (contador === 100) {
        clearInterval(intervalo) // Detiene la ejecución cuando llega a 100
        //console.log("¡Finalizado!")
      }
      if (!isLoading) {
        setContador(99)
      }
      setContador(contador++)
    }, 20) // 100 ms por número = 10,000 ms en total (10 segundos)
  }
  // #endregion

  useEffect(() => {
    //console.log("descuentosInscripcion.length: ", descuentosInscripcion.length)
    if (resetForm === 1) {
      setContador(0)
    }
  }, [resetForm])

  useEffect(() => {
    //console.log("descuentosInscripcion.length: ", descuentosInscripcion.length)
    if (ResetContador) {
      setContador(0)
    }
  }, [ResetContador])

  return (
    <>
      <Card>
        <CardBody>
          {/* Sección de Información General */}
          <h5 className="mb-4">Resumen</h5>
          {/* Alumno */}
          <Row>
            <Col md={4}>
              {" "}
              <div className="mb-3">
                <FormikInput
                  label="Alumno"
                  name="Nombre_Alumno"
                  value={formik.values["Nombre_Alumno"]}
                  readOnly={true}
                  formik={formik}
                />
              </div>
            </Col>
            <Col md={4}>
              {" "}
              <div className="mb-3">
                <FormikInput
                  label="Plan Estudio"
                  name="Nombre_Plan_Estudio"
                  value={formik.values["Nombre_Plan_Estudio"]}
                  readOnly={true}
                  formik={formik}
                />
              </div>
            </Col>
            <Col md={4}>
              {" "}
              <div className="mb-3">
                <FormikInput
                  label="Turno"
                  name="Nombre_Turno"
                  value={formik.values["Nombre_Turno"]}
                  readOnly={true}
                  formik={formik}
                />
              </div>
            </Col>
          </Row>
          {/* Inscripción, Colegiatura, Frecuencia */}
          <Row>
            <Col md={4}>
              {" "}
              <div className="mb-3">
                <FormikInput
                  label="Inscripción"
                  name="Inscripcion"
                  value={`$${formik.values["Importe_Inscripcion"]}`}
                  readOnly={true}
                  formik={formik}
                />
              </div>
            </Col>
            <Col md={4}>
              {" "}
              <div className="mb-3">
                <FormikInput
                  label="Colegiatura"
                  name="Colegiatura"
                  value={`$${formik.values["Importe_Colegiatura"]}`}
                  readOnly={true}
                  formik={formik}
                />
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-3">
                <FormikInput
                  label="Frecuencia"
                  name="Frecuencia"
                  value={formik.values["Frecuencia"]}
                  readOnly={true}
                  formik={formik}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              {" "}
              <div className="wizard clearfix">
                <div className="actions clearfix">
                  <Button
                    type="submit"
                    color={contador > 1 ? "light" : "success"}
                    onClick={() => {
                      contarHasta100()
                    }}
                    disabled={isLoading || !formik.isValid || contador > 1}
                  >
                    {isLoading ? (
                      <>
                        <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                      </>
                    ) : null}{" "}
                    Registrar
                  </Button>
                </div>
              </div>
            </Col>
            {/* <Col>
              {" "}
              <Button
                type="button"
                color="primary"
                onClick={() => {
                  setContador(0)
                }}
              >
                <i className="bx bx-mail-send font-size-16 align-middle me-2"></i>{" "}
                reiniciar
              </Button>
            </Col> */}
          </Row>
        </CardBody>
      </Card>

      {contador > 0 ? (
        <>
          <Card>
            <CardBody>
              <Row className="mt-4">
                <Col>
                  <h5 className="font-size-16">Registrando</h5>
                </Col>
                <Col className="d-flex justify-content-end">
                  <h5 className="font-size-16">
                    {contador === 100 ? "Ok!" : null}
                  </h5>
                </Col>
              </Row>
              <Row>
                <div className="animated-progess mt-0">
                  <Progress
                    value={contador}
                    color="primary"
                    className="progress-xl"
                  ></Progress>
                </div>
              </Row>

              {contador === 100 ? (
                <>
                  <Row>
                    <Col md={6}>
                      <div className="mt-4">
                        <h5 className="font-size-15">Correo de Bienvenida</h5>
                        <div className="mt-2">
                          {" "}
                          <Button
                            type="button"
                            color="primary"
                            onClick={() => {}}
                          >
                            <i className="bx bx-mail-send font-size-16 align-middle me-2"></i>{" "}
                            Enviar
                          </Button>
                        </div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="wizard clearfix">
                        <div className="actions clearfix">
                          <div className="mt-4">
                            <h5 className="font-size-15">Reiniciar</h5>
                            <div className="mt-2">
                              {" "}
                              <Button
                                type="button"
                                color="success"
                                onClick={() => {
                                  setContador(0)
                                  toggleTab(1)
                                }}
                              >
                                <i className="fa fa-angle-double-left"></i>{" "}
                                Reiniciar
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </>
              ) : null}
            </CardBody>
          </Card>
        </>
      ) : null}
    </>
  )
}

export default FormSectionResumen
